import { ChangePasswordFormType } from '../../reducers/PasswordReducer/PasswordReducer.types'
import { ChangePasswordApiRequest } from './mapAccountStateToApi.types'

const map = (changePasswordForm: ChangePasswordFormType): ChangePasswordApiRequest => ({
  old_password: changePasswordForm.currentPassword,
  new_password: changePasswordForm.newPassword,
})

export default map
